import { useAuthContext } from '@aibees/shared/auth/hooks/use-auth-context';
import { useGleap } from '@aibees/shared/hooks';
import { useEffect, useRef } from 'react';

export function useGleapIdentifyEffect() {
  const { user } = useAuthContext();
  const { identify, reset, isUserIdentified } = useGleap();
  const lastUserIdRef = useRef<string | undefined>();

  useEffect(() => {
    const currentUserId = user?.id;

    // Only identify if user has changed or if no user is currently identified
    if (
      user &&
      (currentUserId !== lastUserIdRef.current || !isUserIdentified())
    ) {
      identify(user.id, {
        name: user.firstName + ' ' + user.lastName,
        email: user.email,
        phone: user.attributes?.phone || null,
        value: null,
        plan: null,
        companyId: null,
        companyName: user.attributes?.company || null,
        customData: {
          firstName: user.firstName,
          lastName: user.lastName,
          username: user.username,
          roles: user.roles,
          realmAccessRoles: user.realmAccessRoles,
          title: user.attributes?.title,
          site: user.attributes?.site,
          industry: user.attributes?.industry,
          alternateEmail: user.attributes?.alternateEmail,
          avatar: user.attributes?.avatar,
          lastLogin: new Date().toISOString(),
          customerId: user.id,
        },
      });
      lastUserIdRef.current = currentUserId;
    } else if (!user && lastUserIdRef.current) {
      reset();
      lastUserIdRef.current = undefined;
    }
  }, [user, identify, reset, isUserIdentified]);
}
